<template>
  <div class="judge-performance">
    <h1 class="h2 mb-0">Judge Performance</h1>

    <div class="alert alert-success" v-if="success">{{ success }}</div>
    <div class="alert alert-warning" v-if="error">{{ error }}</div>

    <data-table :dataRows="rows" :dataColumns="columns" :options="options">
      <tableTextTemplate slot-scope="{ row }" slot="expandedHeader" :text="row.event_name" :row="row" />
      <div slot-scope="{ row }" slot="expandedRow">
        <ul class="list-unstyled mb-0 pt-2">
          <li>
            <strong>Draft: </strong>
            <tableTextTemplate :text="row.draft_name" :row="row" :options="{ inline: true }"/>
          </li>
          <li>
            <strong>Event: </strong>
            <tableTextTemplate :text="row.event_name" :row="row" :options="{ inline: true }"/>
          </li>
          <li>
            <strong>Average Rating: </strong>
            <tableTextTemplate :text="row.rating" :row="row" :options="{ inline: true }"/>
          </li>
          <li>
            <strong>Comment: </strong>
            <tableTextTemplate :text="row.comment" :row="row" :options="{ inline: true }"/>
          </li>
        </ul>
      </div>
    </data-table>

  </div>
</template>

<script>
import axios from 'axios'
import dataTable from '@/components/DataTable'
import tableTextTemplate from '@/components/DataTableFields/Text'

export default {
  name: "JudgePerformance",
  components: {
    'data-table': dataTable,
    tableTextTemplate
  },
  props: ['memberId'],
  data() {
    return {
      rows: [],
      options: {
        filter: {},
        search: false,
        loaded: false
      },
      columns: [
        {
          label: 'Draft',
          sortable: false,
          headerClass: 'd-none d-lg-table-cell col-3',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.draft_name" :row="row"/>`
          })
        },
        {
          label: 'Event',
          sortable: false,
          headerClass: 'd-none d-lg-table-cell col-3',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.event_name" :slug="row.id" :row="row"/>`
          })
        },
        {
          label: 'Average Rating',
          sortable: false,
          headerClass: 'd-none d-lg-table-cell col-2',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.rating" :row="row"/>`
          })
        },
        {
          label: 'Comments',
          filterable: false,
          sortable: false,
          headerClass: 'd-none d-lg-table-cell col-4',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.comment" :row="row"/>`
          })
        }
      ],
      success: null,
      error: null
    }
  },
  mounted() {
    this.getJudgePerformanceRating()
  },
  methods: {
    getJudgePerformanceRating() {
      const userId = this.memberId
      axios.get(`${this.$api}/judges/${userId}/performance-rating`)
        .then((response) => {
          if (response.data.status === 'success') {
            this.error = ''
            this.rows = response.data.data
            this.options.loaded = true
          } else {
            this.error = 'Something went wrong. Please try again later.'
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Members/Tabs/JudgePerformance.vue